export default "__VITE_ASSET__DnYmiI54__"